import React from "react";
import MerchantLayout from "../../components/MerchantLayouts";
import BrandAdd from "../../components/Business/BrandAdd";

const myShopBankDemoPage = () => {
  return (
    <MerchantLayout>
      <h1>okkkkkkk</h1>
    </MerchantLayout>
  ); 
};

export default myShopBankDemoPage;
